import mutations from './mutations'
import actions from './actions'
export default {
    state: {
        userInfo: {}, // 会员信息
        cartNum: '', // 购物车数量
        walletState: {},
        // 0未申请、1申请待审核、2申请审核失败、3申请成功待激活、4激活成功
        result: {},
        money: '', // 支付金额
        orderDetail: {}, // 订单信息
        companyCode: '', // 会员店code
        moneyInfo: {},
        paymentAmount: 0,
        tabRemember: 0,
        areaList: [], // 省市区数据
        bankInfo: {}, // 修改银行卡信息
        bankData: {},
        bankSearchList: [],
        myBankList: [],
        assetsUserInfo: {}, // 钱包用户信息
        bankcardWithdrawList: [], // 提现银行卡列表
        cashierdesk: {
            balance: 0,
            bankCards: []
        }, // 支付收银台
        openAccountInfo: {
            accountName: '',
            accountNumber: '',
            bankName: '',
            responseMsg: '',
            status: null
        },
        pageEnterTime: null, // 进入页面的时间
        addressList: {}, // 地址信息
        addressInfo: [], // 多地址信息
        picList: [],
        couponInfo: {
            productList: [],
            totalAmount: 0,
            activityId: '',
            couponArr: []
        },
        couponStatus: false
    },
    mutations,
    actions,
    getters: {
        getAreaList (state, getters) {
            let areaData = localStorage.getItem('areaList') ? JSON.parse(localStorage.getItem('areaList')) : ''
            let data
            if (areaData) {
                data = areaData
            } else {
                data = state.areaList
            }
            const areaList = {
                province_list: {},
                city_list: {},
                county_list: {}
            }
            data.map(item => {
                areaList.province_list[item.provinceId] = item.name
                item.cities.map((itemCities) => {
                    areaList.city_list[itemCities.cityId] = itemCities.name
                    itemCities.countries.map((itemCountries) => {
                        areaList.county_list[itemCountries.countryId] = itemCountries.name
                    })
                })
            })
            return areaList
        },
        bankData (state) {
            return state.bankData
        },
        bankSearchListData (state) {
            return state.bankSearchList
        },
        myBankList (state) {
            return state.myBankList
        },
        addressList (state) {
            return state.addressList
        },
        addressInfo (state) {
            return state.addressInfo
        },
        picList (state) {
            return state.picList
        },
        couponInfo (state) {
            return state.couponInfo
        },
        assetsUserInfo (state) {
            return state.assetsUserInfo
        },
        bankcardWithdrawList (state) {
            return state.bankcardWithdrawList
        },
        cashierdesk (state) {
            return {
                balance: state.cashierdesk.balance || 0,
                walletBalance: state.cashierdesk.walletBalance || 0,
                bankCardsList: state.cashierdesk.bankCards.map(v => {
                    return {
                        text: v.bankName,
                        tip: (v.bankCardType === 10 ? '储蓄卡 ' : '信用卡 ') + v.bankAccountNumber.substring(v.bankAccountNumber.length - 4),
                        value: {
                            payMethod: 20,
                            rate: v.bankCardType === 10 ? 0 : 0.5,
                            bankCardId: v.bankCardId
                        }
                    }
                })
            }
        },
        openAccountInfo (state) {
            return state.openAccountInfo
        }
    }
}
